import React from 'react';
import { Grid } from '@material-ui/core';
import { Switch, Route } from 'react-router-dom';

import Routes from 'config/routes';

import Header from './Header';

import Menu from 'pages/home/menu/Menu';
import RecipesPage from 'pages/recipes/RecipesPage';
import EditRecipePage from 'pages/edit_recipe/EditRecipePage';
import CreateRecipePage from 'pages/create_recipe/CreateRecipePage';

const HomePage = () => {
  return (
    <Grid container direction="column">
      <Grid item container>
        <Header></Header>
      </Grid>

      <Grid item container style={{ marginTop: 64, padding: 16 }}>
        <Switch>
          <Route path={Routes.EDIT_RECIPE}>
            <EditRecipePage></EditRecipePage>
          </Route>

          <Route path={Routes.CREATE_RECIPE_PAGE}>
            <CreateRecipePage />
          </Route>

          <Route path={Routes.RECIPE}>
            <RecipesPage></RecipesPage>
          </Route>

          <Route path={Routes.HOME_PAGE}>
            <Menu></Menu>
          </Route>
        </Switch>
      </Grid>
    </Grid>
  );
};

export default HomePage;
